import React from "react";
import EduPricing from "../../nounproject-edu-pricing";
import LoginForm from "./login-form";
import LoginPageLayout from "./login-page-layout";

const EduLoginPage = () => {
    return (
        <LoginPageLayout
            formSectionContent={
                <LoginForm
                    submitButtonColor="blue"
                    next="/for-edu/apply/"
                    authPathOverride="/for-edu/signup/"
                />
            }
            featuresSectionContent={<EduPricing />}
        />
    );
};

export default EduLoginPage;
